var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      class: _vm.bemBlockMod({
        closed: _vm.isFloatingMenuClosed
      }),
      style: _vm.cssCustomProps,
      attrs: { id: "vue-the-menu" },
      on: {
        mouseleave: function($event) {
          _vm.isBreakpointDesktop && _vm.toggleSelectedCategory()
        }
      }
    },
    [
      _vm.isFloatingMenuOpen
        ? _c("div", {
            class: _vm.bemElement("backdrop"),
            on: {
              touchstart: function($event) {
                $event.preventDefault()
                return _vm.handleCloseMenu($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.bemElement("inner", {
            "is-clip-path": !_vm.isZoomed
          })
        },
        [
          _c(
            "div",
            {
              class: _vm.bemElement("bar"),
              on: {
                click: [
                  _vm.handleOpenMenuClick,
                  function($event) {
                    $event.preventDefault()
                    return _vm.handleToggleMenu($event)
                  }
                ]
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.shouldShowLabel,
                      expression: "shouldShowLabel"
                    }
                  ],
                  ref: "title",
                  class: _vm.bemElement("title")
                },
                [_c("span", [_vm._v(_vm._s(_vm.$msg("menu.title", "header")))])]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: _vm.bemElement("floating-button", {
                    closed: _vm.isFloatingMenuClosed
                  })
                },
                [_c("span", { class: _vm.bemElement("icon", "burger") })]
              )
            ]
          ),
          _vm._v(" "),
          _c("button", {
            class: [_vm.bemElement("btn-close"), "btn-close"],
            on: {
              click: [
                _vm.handleCloseMenuClick,
                function($event) {
                  $event.preventDefault()
                  return _vm.handleCloseMenu($event)
                }
              ]
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.bemElement("layer", { open: !_vm.isClosedMenu }) },
            [
              _c("div", { ref: "wrapper", class: _vm.bemElement("wrapper") }, [
                _c(
                  "ul",
                  {
                    ref: "list",
                    class: _vm.bemElement("list", {
                      overflowing: _vm.overflowing
                    })
                  },
                  [
                    !_vm.searchAIEnabled
                      ? _c(
                          "TheMenuRawItem",
                          {
                            attrs: {
                              bem: "the-menu-search-item",
                              "is-fixed": true,
                              "has-separator-after": true
                            },
                            on: { click: _vm.handleSearchClick }
                          },
                          [
                            _c("i", { staticClass: "icon-search" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$msg("search.menu.link", "search")) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.categories, function(category, index) {
                      return _c("TheMenuItem", {
                        key: index,
                        attrs: {
                          category: category,
                          "inherited-bg-color": _vm.menu.main.categoryBgColor,
                          "is-fixed":
                            _vm.menu.attach_category_id === category.id,
                          "is-submenu-open": _vm.categoryOpen === category.id
                        },
                        on: {
                          "menu:category-open": _vm.toggleSelectedCategory,
                          "menu:update-height": _vm.updateMenuHeight
                        }
                      })
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }